module.exports = __webpack_public_path__ + "static/img/androidDownload.cb0dcb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/androidDownload.png
// module id = /dIC
// module chunks = 1